import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import useSubscribeToSportsEventCache from '@hooks/useSubscribeToSportsEventCache'
import { RefereeInfoProps } from '@widgets/RefereeInfo'
import {
  SubsectionTitle,
  SubsectionWrapper,
} from '@components/LayoutTabs/SubsectionReusableComponents'
import {
  StyledFirstName,
  StyledLastName,
} from '@components/SportCardReusableComponents'

import RefereeImage from './RefereeImage'

type RefereeInfoComponentProps = Omit<RefereeInfoProps, 'typeOfSport'> & {
  typeOfSport: 'soccer'
}

const StyledContentWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing4, spacing8 },
      colors: { strokeDefaultDisabled },
    },
  }) => css`
    display: flex;
    align-items: center;
    gap: ${spacing8};
    padding: ${spacing8};
    border: 1px solid ${strokeDefaultDisabled};
    border-radius: ${spacing4};
  `}
`

const StyledNationality = styled.div`
  ${({
    theme: {
      typography: {
        catchword: {
          small1: { bundledCSS: small1CatchwordCSS },
        },
      },
      colors: { textWeak },
    },
  }) => css`
    ${small1CatchwordCSS};
    color: ${textWeak};
    margin-left: auto;
    text-align: right;
    white-space: nowrap;
  `}
`

const StyledNameWrapper = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

const RefereeInfoComponent: FunctionComponent<RefereeInfoComponentProps> = ({
  title,
  typeOfSport,
  matchId,
}) => {
  const existingSportsEventData = useSubscribeToSportsEventCache({
    matchId,
    typeOfSport,
  })

  if (!existingSportsEventData?.formattedData.referee) {
    return null
  }

  const { firstName, lastName, nationality, image } =
    existingSportsEventData.formattedData.referee

  return (
    <SubsectionWrapper>
      <SubsectionTitle>{title}</SubsectionTitle>
      <StyledContentWrapper>
        <RefereeImage image={image} />
        <StyledNameWrapper>
          <StyledFirstName>{firstName}</StyledFirstName>
          <StyledLastName> {lastName}</StyledLastName>
        </StyledNameWrapper>
        <StyledNationality>{nationality}</StyledNationality>
      </StyledContentWrapper>
    </SubsectionWrapper>
  )
}

export default RefereeInfoComponent
